export const LINKS_RUNTIME_MODULE = "Links";

export const LINKS_ACTIVITY = "LINKS_ACTIVITY";

export const SortingPaths = {
	SourceProcessId: "root.processMetadata.links.sourceProcessId"
};
